import { Plan } from "@bloomstack/apis/planTypes";
import { ReactNode, createContext, useContext, useMemo, useState } from "react";

export type SubscriptionsContextApi = {
  showUpgradeDialog: (upgradePlans: Plan[], currentPlan?: Plan, message?: ReactNode) => void
  hideUpgradeDialog: () => void
}

export const SubscriptionsContext = createContext<SubscriptionsContextApi>(undefined!);

export const useSubscriptions = () => {
  const permCtx = useContext(SubscriptionsContext);
  return permCtx;
};

export type SubscriptionsProviderProps = {
  children: ReactNode
}

export const SubscriptionsProvider = ({ children }: SubscriptionsProviderProps) => {
  // TODO: moving all permissioning to backend. Need to refactor everything here
  //       to streamline how subscriptions function.
  const [showUpgradeDialog, setShowUpgradeDialog] = useState<boolean>(false);
  const [currentPlan, setCurrentPlan] = useState<Plan | undefined>(undefined);
  const [plans, setPlans] = useState<Plan[]>([]);
  const [message, setMessage] = useState<ReactNode>(undefined);

  const api: SubscriptionsContextApi = useMemo(() => ({
    showUpgradeDialog: (upgradePlans: Plan[], currentPlan?: Plan, message?: ReactNode) => {
      setCurrentPlan(currentPlan);
      setPlans(upgradePlans);
      setMessage(message);
      setShowUpgradeDialog(true);
    },
    hideUpgradeDialog: () => {
      setShowUpgradeDialog(false);
    }
  }), [setShowUpgradeDialog]);

  return (
    <SubscriptionsContext.Provider value={api}>
      {children}
      {/* {showUpgradeDialog && (
        <UpgradeDialog
          message={message}
          currentPlan={currentPlan}
          plans={plans}
          onClose={api.hideUpgradeDialog}
        />
      )} */}
    </SubscriptionsContext.Provider>
  )
}